export default __webpack_public_path__ + "rosie.cac032da.png";